import { Formik, FormikHelpers } from "formik"
import { DirtyFormPrompt } from "../form/DirtyFormPrompt"
import { ControlcenterMelcoModelsHoop, UseApiQueryKey, useFormSubmit } from "melco-shared-logic"
import { useQueryClient } from "react-query"
import { useEdithoop } from "../../hooks/hoops/useEditHoop"
import { usePublishHoop } from "../../hooks/hoops/usePublishHoop"
import { DisplayUpdateHoopForm } from "./DisplayUpdateHoopForm"
import { useState } from "react"

type UpdateHoopFormProps = {
    hoop: ControlcenterMelcoModelsHoop;
    refetch: any;
    queryKey: UseApiQueryKey
}


export const UpdateHoopForm: React.FC<UpdateHoopFormProps> = ({ queryKey, refetch, hoop }) => {
    const queryClient = useQueryClient()

    const [initialValues] = useState(hoop);
    const editHoop = useEdithoop();
    const publishHoop = usePublishHoop();



    const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {

        const { submitAction } = values;
        console.log(submitAction)
        if (submitAction === "save")
            await onUpdateHoop(values, formikHelpers, { isManuallyResettingForm: true });
        else
            await onPublishHoop(values, formikHelpers, { isManuallyResettingForm: true })
    }

    const handleSaveAndPublish = async (values: any, formikHelpers: FormikHelpers<any>, options: any) => {

        const { publish } = options;
        // console.log(publish == true ? "true" : "false")
        let newEntity = await editHoop({ ...values })
        if (publish) {
            // publish
            newEntity = await publishHoop(
                values.cloud_id
            )

        }

        // update UI with new Data
        formikHelpers.resetForm({
            values: newEntity ?? hoop
        })


        queryClient.setQueryData(queryKey, newEntity)
        return {
            successMessages: [
                {
                    message: "default"
                }
            ]
        }
    }

    const formSubmitWithPublish = (publish: boolean) => {

        return [
            async (values: any, formikHelpers: FormikHelpers<any>) => {

                return handleSaveAndPublish(values, formikHelpers, { publish })
            }, {
                translationPrefix: ['managehoops.actions', publish ? 'publish' : 'save'].join("."),
                onError: () => {
                    queryClient.invalidateQueries("edithoop")
                }
            }] as const;
    }

    const onUpdateHoop = useFormSubmit(...formSubmitWithPublish(false));
    const onPublishHoop = useFormSubmit(...formSubmitWithPublish(true));


    return (<>
        {hoop && <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            enableReinitialize={true}

        >

            <DirtyFormPrompt>

                <DisplayUpdateHoopForm hoop={hoop} refetch={refetch} />
            </DirtyFormPrompt>
        </Formik >
        }
    </>)
}